import { useQuery } from '@tanstack/react-query';
import { getUserLocations } from './useUserLocationsQuery';

const EMAIL_REGEX = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const useGetUserLocationsByEmail = (email: string | undefined) => {
  const isValidEmail = email ? EMAIL_REGEX.test(email) : false;

  const query = useQuery({
    queryKey: ['selectedUserLocations', email],
    queryFn: async () => {
      if (!email || !isValidEmail) {
        return undefined;
      }
      return (await getUserLocations.get({ email })) as HoneLocationUser[];
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!email && isValidEmail,
  });

  return {
    ...query,
    isValidEmail,
  };
};
